import api from '@/services/api'
import type { AppNotification, NotificationsListResponse } from '@/types/notification'

export async function fetchNotifications(params?: {
  page?: number
  limit?: number
  unreadOnly?: boolean
}): Promise<NotificationsListResponse> {
  const { data } = await api.get<NotificationsListResponse>('/notifications', { params })
  return data
}

export async function fetchUnreadCount(): Promise<number> {
  const { data } = await api.get<{ success: boolean; data: { count: number } }>(
    '/notifications/unread-count',
  )
  return data.data?.count ?? 0
}

export async function markNotificationAsRead(id: string): Promise<void> {
  await api.put(`/notifications/${id}/read`)
}

export async function markAllNotificationsAsRead(): Promise<void> {
  await api.put('/notifications/read-all')
}

export type { AppNotification }
